import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Portal from '@material-ui/core/Portal/Portal';
import classNames from 'classnames';
import React, { FC } from 'react';

import useStyles from './styles';

enum LoaderColors {
  blue400 = 'blue400',
  white = 'white',
  gray200 = 'gray200',
  gray400 = 'gray400',
  gray600 = 'gray600',
  gray800 = 'gray800',
}
export interface LoaderProps {
  block?: boolean;
  className?: string;
  color?: `${LoaderColors}`;
  fullScreen?: boolean;
  fullSection?: boolean;
  size?: string | number;
}

export const Loader: FC<LoaderProps> = ({
  block = false,
  className,
  color = 'blue400',
  fullScreen = false,
  fullSection = false,
  size = '1rem',
}) => {
  const classes = useStyles();

  if (fullScreen)
    return (
      <Portal>
        <Grid alignItems="center" className={classes.fullScreen} container justify="center">
          <CircularProgress className={classNames(className, classes[color])} size={size} />
        </Grid>
      </Portal>
    );

  if (fullSection)
    return (
      <Grid alignItems="center" className={classes.fullSection} container justify="center">
        <CircularProgress className={classNames(className, classes[color])} size={size} />
      </Grid>
    );

  if (block)
    return (
      <Grid alignItems="center" className={classes.block} container justify="center">
        <CircularProgress className={classNames(className, classes[color])} size={size} />
      </Grid>
    );

  return <CircularProgress className={classNames(className, classes[color])} size={size} />;
};

export default Loader;
